import { render } from "./Pelaksanaan.vue?vue&type=template&id=666e3ac5"
import script from "./Pelaksanaan.vue?vue&type=script&lang=js"
export * from "./Pelaksanaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__